import { atom } from '@exodus/jotai';
import { loadable as baseLoadable } from '@exodus/jotai/utils';
import { loadable } from './loadable.js';
const swrCache = new WeakMap();
export function swr(sourceAtom) {
    const cached = swrCache.get(sourceAtom);
    if (cached)
        return cached;
    const created = createSWR(sourceAtom);
    swrCache.set(sourceAtom, created);
    return created;
}
function createSWR(sourceAtom) {
    const loadableAtom = loadable(sourceAtom);
    const cacheKey = sourceAtom.cacheKey;
    const keyLoadableAtom = cacheKey ? baseLoadable(atom((get) => cacheKey(get))) : undefined;
    const swrAtom = atom((get) => {
        const prev = get(swrAtom);
        const source = get(loadableAtom);
        let currentKey;
        if (keyLoadableAtom) {
            const keyState = get(keyLoadableAtom);
            currentKey = keyState.state === 'hasData' ? keyState.data : undefined;
        }
        let base;
        if (source.error !== null) {
            base = {
                data: prev?.data,
                key: prev?.key,
                error: source.error,
                loading: false,
                validating: false,
            };
        }
        else if (source.loading) {
            if (prev?.data === undefined) {
                base = {
                    data: undefined,
                    key: undefined,
                    error: undefined,
                    loading: true,
                    validating: true,
                };
            }
            else {
                base = {
                    data: prev.data,
                    key: prev.key,
                    error: undefined,
                    loading: false,
                    validating: true,
                };
            }
        }
        else {
            base = {
                data: source.data,
                key: currentKey,
                error: undefined,
                loading: false,
                validating: false,
            };
        }
        if (cacheKey && base.data !== undefined) {
            if (currentKey === undefined || base.key !== currentKey) {
                return { ...base, data: undefined, key: undefined };
            }
        }
        return base;
    });
    swrAtom.init = undefined;
    return swrAtom;
}
